import { Injectable } from '@angular/core';

@Injectable()
export class HeaderService {

  constructor() { }

  getHeader(): string {
    return 'Header service';
  }
}
